import { DebugLogger } from '@affine/debug';

export const providerLogger = new DebugLogger('provider');
